import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";

import {
  getData,
  postData,
  getEditData,
  editData,
  deleteData,
  getDimension,
} from "./api";

// import { Per_Page_Dropdown, Select2Data, SelectImageData, RequiredIs } from "./common";

export const Context = createContext();
var HtmlToReactParser = require("html-to-react").Parser;
var htmlToReactParser = new HtmlToReactParser();
const AppContext = ({ children }) => {
  // const IMG_URL = "http://localhost:3786";
  // const IMG_URL = "http://192.168.16.39:4327"; // Ankur
  const IMG_URL = "https://newrevenads-node.profcymabackend.com:4322";

  // const WEB_URL = "http://localhost:4327";
  const WEB_URL = "https://newrevenads-node.profcymabackend.com:4322";

  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");
  const [userdata, setUserData] = useState({});
  const [isAllow, setisAllow] = useState([]);
  const minLength = 2;
  const maxLength = 30;

  useEffect(() => {
    isTokenValid();
  }, [signin]);

  const getuserData = async (id) => {
    // const response = await getData(`/common/auth/admin-login`);

    // await setUserData(response?.data);
    // await setisAllow(response?.data?.permissions);
  };

  console.log("isAllow", isAllow);

  const [user, setUser] = useState({});
  const GetUser = async () => {


    const response = await getData(`/website/user/get-user`);
    // console.log({ GetUser: response });
    if (response?.success) {
      setUser(response?.data);
    } else {
      Cookies.remove("omtapovan_website_security", { path: "/" });

    }
  };

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      Cookies.set("omtapovan_website_security", token, {
        expires: 7,
        secure: true,
        sameSite: "strict",
      });
      // window.history.replaceState({}, document.title, "/home");
      // window.location.reload();
      window.location.href = "/home";


    }
  }, []);

  useEffect(() => {
    GetUser();
    getuserData();
  }, []);

  const isTokenValid = async () => {
    const token = Cookies.get("omtapovan_website_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("omtapovan_website_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
        console.log("I am in exp");
      } else {
        setisAllow(decodedToken?.permissions);
        await getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);
        setSignin(true);
        console.log("I am in success");
      }
    } else {
      setSignin(false);
      setUsertype("");
      setisAllow([]);
      // navigate("/");
      console.log("I am in false");
    }
  };

  // const isTokenValid = async () => {
  //   const token = Cookies.get("omtapovan_website_security");

  //   if (token) {
  //     const decodedToken = JSON.parse(atob(token.split(".")[1]));
  //     const currentTime = Date.now() / 1000;

  //     if (decodedToken.exp < currentTime) {
  //       Cookies.remove("omtapovan_website_security", { path: "/" });
  //       navigate("/Components/DashBoard/DashBoard");
  //     } else {
  //       getuserData(decodedToken.user);
  //       setUsertype(decodedToken.role);
  //       setSignin(true);
  //     }
  //   } else {
  //     navigate("/Components/DashBoard/DashBoard");
  //   }
  // };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const [bookingData, setBookingData] = useState({
    check_in_date: "",
    check_in_time: "",
    check_out_date: "",
    check_out_time: "",
    extra_persons: "",
  });
  return (
    <Context.Provider
      value={{
        IMG_URL,
        getData,
        postData,
        // getEditData,
        // editData,
        deleteData,
        // minLength,
        // maxLength,
        signin,
        setSignin,
        // usertype,
        // setUsertype,
        // userdata,
        // setUserData,
        // getDownloadDataExcel,
        // ErrorNotify,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        // Select2Data,
        // SelectImageData,
        // Per_Page_Dropdown,
        // RequiredIs,
        getDimension,
        // isAllow,
        // user,
        htmlToReactParser,
        WEB_URL,
        // getuserData,
        bookingData, setBookingData
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
